import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import web from "../images/coding.png"
import design from "../images/design.png"
import dm from "../images/seo.png"
import skillsman from "../images/services man.png"


function Skills() {

return(
       <div>
        <Navbar/>
 <section class="services">
        <div class="container">
            <h2 class="headerText">Skills</h2>
                      <div class="row">
                        <div class="col-lg-8">
                                   <div class="cards">
                                    <div class="card-content">
                                        <div class="card-content-front">
                                            <div class="content">
                                                <h4>Front-end</h4>
                                                <img src={web} alt="webIMG"/>

                                            </div>
                                              <p>I develop front-end with coding super smooth</p>
                                            </div>
                                            <div class="card-content-back">
                                                <h4 class="next">What i can do</h4>
                                                <div class="icons">
                                                    <i class="fa-brands fa-react"></i>
                                                <i class="fa-brands fa-js"></i>
                                                <i class="fa-brands fa-angular"></i>
                                                <i class="fa-brands fa-wordpress"></i>

                                                </div>
                                            </div>

                                        </div>
                                      
                                   </div>

                                   <div class="cards">
                                    <div class="card-content">
                                        <div class="card-content-front">
                                            <div class="content">
                                                <h4>UI/UX Design</h4>
                                                 <img src={design} alt="DESIGNlogo" />
                                            </div>  
                                            <p>Create digital products with unique ideas</p>
                                        </div>
                                            <div class="card-content-back">
                                                <h4 class="next">What i can do</h4>
                                                <div class="icons">
                                                    <i class="fa-brands fa-figma"></i>

                                                </div>
                                                
                                            </div>

                                    </div>
                                      
                                   </div>

                                   <div class="cards">
                                    <div class="card-content">
                                        <div class="card-content-front">
                                            <div class="content">
                                                <h4>S.E.O</h4>
                                                <img src={dm} alt="seo" />
                                            </div> 
                                             <p>Boost your business with S.E.O optimise</p>
                                        </div>
                                            <div class="card-content-back">
                                                <h4 class="next">What i can do</h4>
                                                 <h2>S.E.O</h2>
                                            </div>

                                    </div>
                                      
                                   </div>

                        </div>
                        <div class="col-lg-4">
                            <div class="testimonials-img">
                                <img src={skillsman} alt="testimonials" class="img-fluid" />

                            </div>
                            
                            
                        </div>


                     </div>
         </div>

    </section>
          <Footer/>
       </div>



)
    
}
export default  Skills